import React from "react";
import { useTranslation } from "react-i18next";

import Button from "../../../../components/Button";
import Modal from "../../../../components/v2/Modal";

import style from "./styles.module.scss";

const keyI18n = "translations.admin.transparency.publication";

export type PublicationAction = "publish" | "replace" | "unpublish";

interface Props {
  action: PublicationAction | null;
  replacedTitle?: string;
  busy: boolean;
  onCancel(): void;
  onConfirm(): void;
}

export default function PublicationDialog({ action, replacedTitle, busy, onCancel, onConfirm }: Props) {
  const { t } = useTranslation();

  if (!action) {
    return null;
  }

  const unpublish = action === "unpublish";

  return (
    <Modal
      open
      onClose={busy ? () => undefined : onCancel}
      dismissible={!busy}
      title={t(`${keyI18n}.${action}.title`)}
      size="small"
      actions={(
        <>
          <Button variant="text" shape="round" size="small" onClick={onCancel} disabled={busy}>
            {t(`${keyI18n}.cancel`)}
          </Button>
          <Button
            variant="filled"
            shape="round"
            size="small"
            onClick={onConfirm}
            disabled={busy}
            icon={<span className="material-symbols-sharp">{unpublish ? "unpublished" : "publish"}</span>}
          >
            {t(`${keyI18n}.${action}.confirm`)}
          </Button>
        </>
      )}
    >
      <div className={style.dialogText}>
        <p className="pgm-body-large">{t(`${keyI18n}.${action}.description`, { period: replacedTitle })}</p>
        <p className="pgm-body-large">{t(`${keyI18n}.${action}.question`)}</p>
      </div>
    </Modal>
  );
}
